module.exports = __webpack_public_path__ + "static/media/company-logo.76cf9af2.png";